<div class="cuadro-picnic-page">
  <!-- Top Warning Alert Banner for 3 Consecutive Snack Days (UX/UI Design System Compliant) -->
  <section
    class="consecutive-snack-alert-banner"
    [class.is-collapsed]="!isSnackAlertListExpanded"
    *ngIf="consecutiveSnackAlertList.length > 0 && !isSnackAlertBannerDismissed"
    aria-label="Alerta operativa de variedad de alimentos"
  >
    <!-- Banner Main Header Strip -->
    <div class="alert-banner-header">
      <div class="alert-header-left">
        <div class="alert-icon-shell">
          <i-tabler name="alert-triangle" class="warning-icon"></i-tabler>
        </div>
        <div class="alert-title-group">
          <div class="title-and-badge-row">
            <span class="alert-eyebrow"
              >ALERTA OPERATIVA · VARIEDAD DE MENÚ</span
            >
            <span class="alert-count-pill">
              {{ consecutiveSnackAlertList.length }}
              {{
                consecutiveSnackAlertList.length === 1
                  ? "File detectado"
                  : "Files detectados"
              }}
            </span>
            <span
              class="active-filtered-badge"
              *ngIf="activeAlertFilterFileNumber"
            >
              <i-tabler name="eye" class="badge-icon"></i-tabler>
              <span>Mostrando File {{ activeAlertFilterFileNumber }}</span>
            </span>
          </div>
          <h2 class="alert-main-title">
            Servicio de SNACK programado por 3 o más días consecutivos
          </h2>
          <p class="alert-description">
            Se detectaron pasajeros con raciones continuas de Snack. Se sugiere
            coordinar con el Ejecutivo(a) de Reservas para evaluar alternativas
            de menú (Picnic o Box Lunch).
          </p>
        </div>
      </div>

      <div class="alert-header-actions">
        <!-- Button to restore full view when filtering by alert file -->
        <button
          type="button"
          class="btn-clear-alert-filter"
          *ngIf="activeAlertFilterFileNumber"
          (click)="clearAlertFileFilter()"
          matTooltip="Restablecer tabla para ver todos los files"
        >
          <i-tabler name="filter-off" class="btn-icon"></i-tabler>
          <span>Ver todos los files</span>
        </button>

        <button
          type="button"
          class="btn-toggle-alert-expand"
          (click)="toggleSnackAlertListExpansion()"
          [matTooltip]="
            isSnackAlertListExpanded
              ? 'Minimizar tarjetas de files'
              : 'Ver detalle de files afectados'
          "
        >
          <i-tabler
            [name]="isSnackAlertListExpanded ? 'chevron-up' : 'chevron-down'"
            class="toggle-icon"
          ></i-tabler>
          <span>{{
            isSnackAlertListExpanded
              ? "Ocultar detalle"
              : "Ver files afectados (" + consecutiveSnackAlertList.length + ")"
          }}</span>
        </button>

        <button
          type="button"
          class="btn-dismiss-alert"
          (click)="dismissSnackAlertBanner()"
          matTooltip="Ocultar alerta por esta sesión"
          aria-label="Cerrar alerta"
        >
          <i-tabler name="x" class="dismiss-icon"></i-tabler>
        </button>
      </div>
    </div>

    <!-- Alert Cards Grid (Visible when expanded) -->
    <div class="alert-cards-grid" *ngIf="isSnackAlertListExpanded">
      <div
        class="file-alert-card"
        [class.is-filtered-active]="
          activeAlertFilterFileNumber === alertItem.fileNumber
        "
        *ngFor="let alertItem of consecutiveSnackAlertList"
      >
        <div class="card-left-info">
          <!-- File Code & Client / Itinerary Identification -->
          <div class="card-file-row">
            <span class="file-code-badge">
              <i-tabler name="folder" class="badge-icon"></i-tabler>
              <span>File {{ alertItem.fileNumber }}</span>
            </span>
            <strong
              class="client-name-text"
              [matTooltip]="alertItem.clientName"
            >
              {{ alertItem.clientName }}
            </strong>
            <span
              class="itinerary-name-text"
              *ngIf="alertItem.nombreItinerario"
              [matTooltip]="alertItem.nombreItinerario"
            >
              · {{ alertItem.nombreItinerario }}
            </span>
          </div>

          <!-- Consecutive Dates Row -->
          <div class="consecutive-dates-row">
            <span class="dates-label">
              <i-tabler name="calendar-event" class="calendar-icon"></i-tabler>
              <span>Fechas continuas:</span>
            </span>
            <div class="dates-chips-wrapper">
              <span
                class="snack-date-pill"
                *ngFor="let dateStr of alertItem.consecutiveDates"
              >
                {{ formatLocalDateToDisplay(dateStr) }}
              </span>
            </div>
          </div>

          <!-- Reservation Executive Row (if present) -->
          <div
            class="executive-row"
            *ngIf="
              alertItem.reservationExecutives &&
              alertItem.reservationExecutives.length > 0
            "
          >
            <span class="exec-label">
              <i-tabler name="mail" class="mail-icon"></i-tabler>
              <span>Ejecutivo(a):</span>
            </span>
            <span class="exec-email-badge">
              {{ alertItem.reservationExecutives.join(", ") }}
            </span>
          </div>
        </div>

        <!-- Action Button: Filter File in Table -->
        <div class="card-right-action">
          <button
            type="button"
            class="btn-filter-alert-file"
            [class.is-active]="
              activeAlertFilterFileNumber === alertItem.fileNumber
            "
            (click)="filterByFileNumber(alertItem.fileNumber)"
            [matTooltip]="
              activeAlertFilterFileNumber === alertItem.fileNumber
                ? 'Mostrando actualmente este File. Clic para mostrar todos.'
                : 'Filtrar la tabla por este número de File'
            "
          >
            <i-tabler
              [name]="
                activeAlertFilterFileNumber === alertItem.fileNumber
                  ? 'check'
                  : 'filter'
              "
              class="btn-icon"
            ></i-tabler>
            <span>{{
              activeAlertFilterFileNumber === alertItem.fileNumber
                ? "Mostrando en tabla"
                : "Ver en tabla"
            }}</span>
          </button>
        </div>
      </div>
    </div>
  </section>

  <!-- Page Hero Component -->
  <div class="page-hero">
    <div class="hero-left-block">
      <div class="eyebrow-pill">
        <i-tabler name="soup" class="eyebrow-icon"></i-tabler>
        <span>OPERACIONES · ALIMENTOS & BEBIDAS</span>
      </div>
      <h1 class="hero-title">Cuadro Picnic</h1>
      <p class="hero-subtitle">
        Control operativo y proyección de raciones para pasajeros, guías,
        choferes y personal de campo en servicios de picnic, snacks y treks.
      </p>
    </div>

    <div class="hero-right-block">
      <div class="stats-group">
        <div class="stat-card">
          <span class="stat-label">SNACK</span>
          <strong class="stat-value">{{
            summaryMetricsRecord.snackCount
          }}</strong>
        </div>
        <div class="stat-card">
          <span class="stat-label">PICNIC</span>
          <strong class="stat-value">{{
            summaryMetricsRecord.picnicCount
          }}</strong>
        </div>
        <div class="stat-card">
          <span class="stat-label">BOX LUNCH</span>
          <strong class="stat-value">{{
            summaryMetricsRecord.boxLunchCount
          }}</strong>
        </div>
        <div class="stat-card">
          <span class="stat-label">TREKS</span>
          <strong class="stat-value">{{
            summaryMetricsRecord.trekInkaTrailCount +
              summaryMetricsRecord.trekAusangateCount
          }}</strong>
        </div>
        <div class="stat-card">
          <span class="stat-label">DONATIVO</span>
          <strong class="stat-value">{{
            summaryMetricsRecord.donativoCount
          }}</strong>
        </div>
      </div>

      <button
        mat-raised-button
        class="cta-refresh-btn"
        (click)="loadCuadroPicnicData()"
        [disabled]="isLoadingData"
      >
        <i-tabler
          name="refresh"
          [class.spin-icon]="isLoadingData"
          class="btn-icon"
        ></i-tabler>
        <span>Actualizar</span>
      </button>
    </div>
  </div>

  <!-- Filters Card Component -->
  <div class="filters-card">
    <div class="filters-header">
      <div class="filters-title-container">
        <div class="title-with-badge">
          <i-tabler name="adjustments-horizontal" class="tune-icon"></i-tabler>
          <span class="filters-title">Filtros</span>
          <span class="badge-count" *ngIf="activeFiltersCount > 0">{{
            activeFiltersCount
          }}</span>
        </div>
        <span class="filters-subtitle"
          >Filtra por fechas de operación, número de file o tipo de
          alimento.</span
        >
      </div>

      <button
        mat-stroked-button
        class="btn-clear-filters"
        *ngIf="activeFiltersCount > 0"
        (click)="resetTableFilters()"
      >
        <i-tabler name="filter-off"></i-tabler>
        <span>Limpiar filtros</span>
      </button>
    </div>

    <!-- Filters Row: Buscador General, Año, Fecha de Operación, Tipo de Alimento -->
    <div class="filters-fields-row primary-filters-row">
      <!-- 1. Buscador General (#file o nombre de itinerario) -->
      <div class="search-filter-cell">
        <mat-form-field appearance="outline" class="filter-field filter-search">
          <mat-label>Buscar #file o nombre de Itinerario</mat-label>
          <i-tabler matPrefix name="search" class="field-icon"></i-tabler>
          <input
            matInput
            type="search"
            autocomplete="off"
            placeholder="Ej. 202501234 o Machu"
            [ngModel]="filterCriteriaRecord.searchKeyword"
            (ngModelChange)="onSearchKeywordChange($event)"
          />
          <button
            mat-icon-button
            matSuffix
            type="button"
            *ngIf="filterCriteriaRecord.searchKeyword"
            (click)="clearSearchKeyword($event)"
            class="clear-field-btn"
            matTooltip="Limpiar buscador"
          >
            <i-tabler name="x"></i-tabler>
          </button>
        </mat-form-field>
        <span *ngIf="searchValidationMessage" class="search-validation-message">
          {{ searchValidationMessage }}
        </span>
        <span *ngIf="!searchValidationMessage" class="search-helper-message">
          Texto por itinerario o mínimo 4 dígitos para número de file
        </span>
      </div>

      <!-- 2. Año -->
      <div class="year-filter-cell">
        <mat-form-field
          appearance="outline"
          class="filter-field select-field year-field"
        >
          <mat-label>Año</mat-label>
          <i-tabler matPrefix name="calendar" class="field-icon"></i-tabler>
          <mat-select
            [(value)]="filterCriteriaRecord.selectedYear"
            (selectionChange)="onYearChange($event.value)"
          >
            <mat-option
              *ngFor="let yearItem of availableYearsList"
              [value]="yearItem"
            >
              {{ yearItem }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <!-- 3. Fecha de Operación -->
      <div class="date-filter-cell">
        <mat-form-field appearance="outline" class="filter-field date-field">
          <mat-label>Fecha de Operación</mat-label>
          <mat-date-range-input [rangePicker]="operacionDatePicker">
            <input
              matStartDate
              placeholder="Desde"
              [(ngModel)]="filterCriteriaRecord.startDate"
            />
            <input
              matEndDate
              placeholder="Hasta"
              [(ngModel)]="filterCriteriaRecord.endDate"
              (dateChange)="handleEndDateInputChange()"
            />
          </mat-date-range-input>
          <button
            mat-icon-button
            matSuffix
            type="button"
            *ngIf="
              filterCriteriaRecord.startDate || filterCriteriaRecord.endDate
            "
            (click)="clearDateRangeFilter($event)"
            matTooltip="Limpiar fechas"
            class="btn-clear-date"
          >
            <i-tabler name="x"></i-tabler>
          </button>
          <mat-datepicker-toggle
            matSuffix
            [for]="operacionDatePicker"
          ></mat-datepicker-toggle>
          <mat-date-range-picker
            #operacionDatePicker
            (closed)="handleDatePickerClosed()"
          ></mat-date-range-picker>
        </mat-form-field>
      </div>

      <!-- 4. Tipo de Alimento -->
      <div class="type-filter-cell">
        <mat-form-field appearance="outline" class="filter-field select-field">
          <mat-label>Tipo de Alimento</mat-label>
          <i-tabler
            matPrefix
            name="tools-kitchen-2"
            class="field-icon"
          ></i-tabler>
          <mat-select
            [(value)]="filterCriteriaRecord.selectedServiceType"
            (selectionChange)="onServiceTypeChange($event.value)"
          >
            <mat-option value="">Todos los Tipos</mat-option>
            <mat-option
              *ngFor="let serviceTypeItem of availableServiceTypesList"
              [value]="serviceTypeItem"
            >
              {{ serviceTypeItem }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <!-- Active Filter Chips Footer -->
    <div class="filters-chips-footer">
      <span class="chips-label">ACTIVOS:</span>
      <div
        class="chips-container"
        *ngIf="activeFilterChips.length > 0; else noActiveFilters"
      >
        <span class="filter-chip" *ngFor="let chip of activeFilterChips">
          <strong>{{ chip.label }}:</strong> {{ chip.value }}
          <button class="chip-remove-btn" (click)="removeFilter(chip.key)">
            <i-tabler name="x"></i-tabler>
          </button>
        </span>
      </div>
      <ng-template #noActiveFilters>
        <span class="empty-chips-text">Sin filtros activos</span>
      </ng-template>
    </div>
  </div>

  <!-- Expandable Legend Guide (Guía Operativa Rápida) -->
  <div class="legend-card">
    <div class="legend-summary" (click)="toggleLegend()">
      <div class="legend-summary-left">
        <div class="legend-icon-shell">
          <i-tabler name="help-circle"></i-tabler>
        </div>
        <div class="legend-text-box">
          <span class="legend-eyebrow">GUÍA OPERATIVA</span>
          <h3 class="legend-title">Guía y Significado de Columnas</h3>
          <p class="legend-desc">
            Consulta rápida sobre tipos de alimentos, cálculo de raciones,
            servicios logísticos y estados de revisión.
          </p>
        </div>
      </div>
      <button mat-stroked-button class="legend-toggle-btn">
        <i-tabler
          [name]="isLegendExpanded ? 'chevron-up' : 'chevron-down'"
        ></i-tabler>
        <span>{{
          isLegendExpanded ? "Ocultar guía" : "Ver guía detallada"
        }}</span>
      </button>
    </div>

    <div class="legend-expanded-grid" *ngIf="isLegendExpanded">
      <!-- 1. Itinerario y Datos Generales -->
      <div class="legend-section">
        <div class="section-header">
          <div class="section-icon-shell">
            <i-tabler name="map"></i-tabler>
          </div>
          <div class="section-title-wrap">
            <h4 class="section-title">Itinerario y Datos</h4>
            <span class="section-cols-badge">Cols. 1–5, 7</span>
          </div>
        </div>

        <div class="legend-items-list">
          <div class="legend-item-card">
            <div class="item-badge-wrap">
              <span class="legend-badge badge-neutral">
                <i-tabler name="calendar"></i-tabler>
                <span>F. Operación</span>
              </span>
            </div>
            <div class="item-content">
              <strong class="item-label">Fecha de Operación</strong>
              <p class="item-desc">
                Día exacto en que se realiza el servicio de alimentación en
                campo.
              </p>
            </div>
          </div>

          <div class="legend-item-card">
            <div class="item-badge-wrap multi-badges">
              <span class="legend-badge badge-neutral">
                <i-tabler name="file-text"></i-tabler>
                <span>File</span>
              </span>
              <span class="legend-badge badge-padre">
                <i-tabler name="layers-intersect"></i-tabler>
                <span>SSFF</span>
              </span>
            </div>
            <div class="item-content">
              <strong class="item-label">Código y Nombre del File</strong>
              <p class="item-desc">
                Identificador y título comercial del itinerario. El distintivo
                <strong>SSFF</strong> identifica exclusivamente los itinerarios
                matrices de <em>Salidas Fijas</em> (isSSFFPadre: true).
              </p>
            </div>
          </div>

          <div class="legend-item-card">
            <div class="item-badge-wrap">
              <span class="legend-badge badge-neutral">
                <i-tabler name="user-check"></i-tabler>
                <span>Cliente</span>
              </span>
            </div>
            <div class="item-content">
              <strong class="item-label">Cliente o Agencia</strong>
              <p class="item-desc">
                Nombre de la agencia de viajes o cliente directo que contrata el
                viaje.
              </p>
            </div>
          </div>

          <div class="legend-item-card">
            <div class="item-badge-wrap">
              <span class="legend-badge badge-neutral">
                <i-tabler name="mail"></i-tabler>
                <span>Ejecutivo(a)</span>
              </span>
            </div>
            <div class="item-content">
              <strong class="item-label">Ejecutivo de Reservas</strong>
              <p class="item-desc">
                Asesor responsable de la venta y emisión de la orden de pedido.
              </p>
            </div>
          </div>

          <div class="legend-item-card">
            <div class="item-badge-wrap">
              <span class="legend-badge badge-guide">
                <i-tabler name="user"></i-tabler>
                <span>Guía Principal</span>
              </span>
            </div>
            <div class="item-content">
              <strong class="item-label">Guía Oficial Asignado</strong>
              <p class="item-desc">
                Guía principal que lidera el grupo de pasajeros en la ruta.
              </p>
            </div>
          </div>

          <div class="legend-item-card">
            <div class="item-badge-wrap">
              <span class="legend-badge badge-neutral">
                <i-tabler name="route"></i-tabler>
                <span>Actividad</span>
              </span>
            </div>
            <div class="item-content">
              <strong class="item-label">Actividad del Día</strong>
              <p class="item-desc">
                Nombre de la excursión o visita programada en esa fecha.
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- 2. Tipos de Alimentos -->
      <div class="legend-section">
        <div class="section-header">
          <div class="section-icon-shell">
            <i-tabler name="tools-kitchen-2"></i-tabler>
          </div>
          <div class="section-title-wrap">
            <h4 class="section-title">Tipos de Alimento</h4>
            <span class="section-cols-badge">Col. 6</span>
          </div>
        </div>

        <div class="legend-items-list">
          <div class="legend-item-card">
            <div class="item-badge-wrap">
              <span class="legend-type-pill pill-snack">SNACK</span>
            </div>
            <div class="item-content">
              <strong class="item-label">Refrigerio / Snack</strong>
              <p class="item-desc">
                Bocadillos y frutas ligeras servidos entre actividades o
                trayectos.
              </p>
              <span class="item-note note-warning">
                <i-tabler name="alert-triangle"></i-tabler> Alerta si se repite
                en 3+ días consecutivos
              </span>
            </div>
          </div>

          <div class="legend-item-card">
            <div class="item-badge-wrap">
              <span class="legend-type-pill pill-picnic">PICNIC</span>
            </div>
            <div class="item-content">
              <strong class="item-label">Picnic al Aire Libre</strong>
              <p class="item-desc">
                Almuerzo campestre formal con montaje de mesas, menajería y
                asistentes.
              </p>
            </div>
          </div>

          <div class="legend-item-card">
            <div class="item-badge-wrap">
              <span class="legend-type-pill pill-boxlunch">BOX LUNCH</span>
            </div>
            <div class="item-content">
              <strong class="item-label">Almuerzo para Llevar</strong>
              <p class="item-desc">
                Ración empacada para que el pasajero lleve en caminatas o
                traslados.
              </p>
            </div>
          </div>

          <div class="legend-item-card">
            <div class="item-badge-wrap">
              <span class="legend-type-pill pill-trek">ALIM TREK</span>
            </div>
            <div class="item-content">
              <strong class="item-label">Alimentación de Trekking</strong>
              <p class="item-desc">
                Pensión completa de campamento (desayuno, almuerzo, lonche,
                cena) en rutas de aventura.
              </p>
            </div>
          </div>

          <div class="legend-item-card">
            <div class="item-badge-wrap">
              <span class="legend-type-pill pill-donativo">DONATIVO</span>
            </div>
            <div class="item-content">
              <strong class="item-label">Donativo</strong>
              <p class="item-desc">
                Aporte o entrega de alimentos/raciones con fines benéficos o
                comunitarios.
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- 3. Raciones y Comensales -->
      <div class="legend-section">
        <div class="section-header">
          <div class="section-icon-shell">
            <i-tabler name="users"></i-tabler>
          </div>
          <div class="section-title-wrap">
            <h4 class="section-title">Raciones y Personas</h4>
            <span class="section-cols-badge">Cols. 8–18</span>
          </div>
        </div>

        <div class="legend-items-list">
          <div class="legend-item-card">
            <div class="item-badge-wrap multi-badges">
              <span class="legend-badge badge-guide">PAX</span>
              <span class="legend-badge badge-guide">TC</span>
              <span class="legend-badge badge-guide">GUIA</span>
            </div>
            <div class="item-content">
              <strong class="item-label">Pax, TC y Guía</strong>
              <p class="item-desc">
                Pasajeros confirmados, Tour Conductor y Guía Oficial asignado.
              </p>
            </div>
          </div>

          <div class="legend-item-card">
            <div class="item-badge-wrap multi-badges">
              <span class="legend-badge badge-pax">ASIST</span>
              <span class="legend-badge badge-pax">CHOFER</span>
            </div>
            <div class="item-content">
              <strong class="item-label">Asistente y Conductor</strong>
              <p class="item-desc">
                Asistente de Guía y Chofer del transporte en ruta.
              </p>
            </div>
          </div>

          <div class="legend-item-card">
            <div class="item-badge-wrap multi-badges">
              <span class="legend-badge badge-staff">PER. CAMPO</span>
              <span class="legend-badge badge-staff">STAFF</span>
            </div>
            <div class="item-content">
              <strong class="item-label">Cocina y Operaciones</strong>
              <p class="item-desc">
                Cocineros, ayudantes, arrieros y personal de apoyo logístico.
              </p>
            </div>
          </div>

          <div class="legend-item-card">
            <div class="item-badge-wrap multi-badges">
              <span class="legend-badge badge-kids">INFANTE</span>
              <span class="legend-badge badge-kids">NIÑO</span>
            </div>
            <div class="item-content">
              <strong class="item-label">Menores de Edad</strong>
              <p class="item-desc">
                <strong>Infante:</strong> &lt; 3 años (sin ración completa).
                <strong>Niño:</strong> 3 a 12 años.
              </p>
            </div>
          </div>

          <div class="legend-item-card">
            <div class="item-badge-wrap">
              <span class="legend-badge badge-danger">
                <i-tabler name="alert-circle"></i-tabler>
                <span>Restricciones</span>
              </span>
            </div>
            <div class="item-content">
              <strong class="item-label">Dietas y Alergias</strong>
              <p class="item-desc">
                Vegetarianos, celíacos, alergias alimentarias u opciones médicas
                especiales.
              </p>
            </div>
          </div>

          <div class="legend-item-card highlight-card">
            <div class="item-badge-wrap">
              <span class="legend-badge badge-total">
                <i-tabler name="calculator"></i-tabler>
                <span>TOTAL</span>
              </span>
            </div>
            <div class="item-content">
              <strong class="item-label">Total de Raciones</strong>
              <p class="item-desc">
                Suma global de comensales.
                <span class="item-action-hint"
                  >💡 Clic en la celda para ver el desglose completo.</span
                >
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- 4. Logística, O.S. y Control -->
      <div class="legend-section">
        <div class="section-header">
          <div class="section-icon-shell">
            <i-tabler name="checkup-list"></i-tabler>
          </div>
          <div class="section-title-wrap">
            <h4 class="section-title">Logística y Control</h4>
            <span class="section-cols-badge">Cols. 19–25</span>
          </div>
        </div>

        <div class="legend-items-list">
          <div class="legend-item-card">
            <div class="item-badge-wrap">
              <span class="legend-badge badge-op">
                <i-tabler name="truck"></i-tabler>
                <span>Emp. Transporte</span>
              </span>
            </div>
            <div class="item-content">
              <strong class="item-label">Transporte de Picnic</strong>
              <p class="item-desc">
                Vehículo logístico asignado para el traslado de carpas, mesas y
                vajilla.
              </p>
            </div>
          </div>

          <div class="legend-item-card">
            <div class="item-badge-wrap">
              <span class="legend-badge badge-op">
                <i-tabler name="user-plus"></i-tabler>
                <span>Asist. Picnic</span>
              </span>
            </div>
            <div class="item-content">
              <strong class="item-label">Asistente de Montaje</strong>
              <p class="item-desc">
                Personal designado para armar, servir y desarmar el servicio de
                picnic.
              </p>
            </div>
          </div>

          <div class="legend-item-card">
            <div class="item-badge-wrap">
              <span class="legend-badge badge-op">
                <i-tabler name="home-2"></i-tabler>
                <span>Bañero</span>
              </span>
            </div>
            <div class="item-content">
              <strong class="item-label">Baño Portátil</strong>
              <p class="item-desc">
                Servicio de carpa baño químico o portátil para la locación del
                almuerzo.
              </p>
            </div>
          </div>

          <div class="legend-item-card">
            <div class="item-badge-wrap">
              <span class="legend-badge badge-op">
                <i-tabler name="briefcase"></i-tabler>
                <span>Espacio Picnic</span>
              </span>
            </div>
            <div class="item-content">
              <strong class="item-label">Espacio Picnic</strong>
              <p class="item-desc">
                Servicio operativo de operador tercerizado o locación asignada para el
                desarrollo de la actividad de picnic.
              </p>
            </div>
          </div>

          <div class="legend-item-card">
            <div class="item-badge-wrap">
              <span class="legend-badge badge-os">
                <i-tabler name="file-invoice"></i-tabler>
                <span>Pill (X/Y OS)</span>
              </span>
            </div>
            <div class="item-content">
              <strong class="item-label">Órdenes de Servicio (O.S.)</strong>
              <p class="item-desc">
                Progreso de O.S. generadas vs requeridas.
                <span class="item-action-hint"
                  >💡 Clic para asignar proveedor.</span
                >
              </p>
            </div>
          </div>

          <div class="legend-item-card">
            <div class="item-badge-wrap">
              <span class="legend-badge badge-success">
                <i-tabler name="checkbox"></i-tabler>
                <span>Rev. Pedido</span>
              </span>
            </div>
            <div class="item-content">
              <strong class="item-label">Revisión de Pedido (A&B)</strong>
              <p class="item-desc">
                Casilla que confirma que la ración y menú han sido auditados por
                logística.
              </p>
            </div>
          </div>

          <div class="legend-item-card">
            <div class="item-badge-wrap">
              <div class="status-pills-row">
                <span class="status-mini-pill status-ok">OK</span>
                <span class="status-mini-pill status-pending">Pendiente</span>
                <span class="status-mini-pill status-none">Sin AC</span>
              </div>
            </div>
            <div class="item-content">
              <strong class="item-label">Revisión de Biblia (AC)</strong>
              <p class="item-desc">
                <strong>OK:</strong> Sin observaciones.
                <strong>Pendiente:</strong> Observación abierta.
                <strong>Sin AC:</strong> Sin registrar.
              </p>
            </div>
          </div>

          <div class="legend-item-card">
            <div class="item-badge-wrap">
              <span class="legend-badge badge-neutral">
                <i-tabler name="notes"></i-tabler>
                <span>Observaciones</span>
              </span>
            </div>
            <div class="item-content">
              <strong class="item-label">Observaciones Operativas</strong>
              <p class="item-desc">
                Instrucciones o requerimientos especiales indicados por la
                programadora.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Filtering Indicator -->
  <div class="filtering-indicator" *ngIf="isFiltering">
    <mat-progress-bar mode="indeterminate" color="accent"></mat-progress-bar>
    <span>Actualizando resultados...</span>
  </div>

  <!-- Table Toolbar -->
  <div class="table-toolbar">
    <div class="toolbar-left">
      <i-tabler name="table" class="toolbar-icon"></i-tabler>
      <span class="count-text" *ngIf="!isLoadingData || isFiltering">
        <strong>{{ masterPicnicItems.length }}</strong> servicios de
        alimentación cargados
      </span>
      <span class="count-text" *ngIf="isLoadingData && !isFiltering">
        Cargando servicios de alimentación...
      </span>
    </div>
    <div class="toolbar-right">
      <span class="toolbar-hint"
        >Haz clic en <strong>Total</strong> para ver el modal con el desglose de
        raciones y restricciones.</span
      >
    </div>
  </div>

  <!-- Table Surface Container -->
  <div class="table-surface">
    <!-- Loading Progress Bar -->
    <mat-progress-bar
      mode="indeterminate"
      color="accent"
      *ngIf="isLoadingData && !isFiltering"
      class="table-loading-bar"
    ></mat-progress-bar>

    <!-- Skeleton Table (Initial Load) -->
    <div class="skeleton-table" *ngIf="isLoadingData && !isFiltering">
      <div class="sk-row sk-header-row">
        <div class="sk-cell sk-file">
          <div class="sk-line shimmer sk-w-50"></div>
        </div>
        <div class="sk-cell sk-medium">
          <div class="sk-line shimmer sk-w-55"></div>
        </div>
        <div class="sk-cell sk-medium">
          <div class="sk-line shimmer sk-w-80"></div>
        </div>
        <div class="sk-cell sk-center">
          <div class="sk-line shimmer sk-w-50"></div>
        </div>
        <div class="sk-cell sk-date">
          <div class="sk-line shimmer sk-w-80"></div>
        </div>
        <div class="sk-cell sk-review">
          <div class="sk-line shimmer sk-w-110"></div>
        </div>
        <div class="sk-cell sk-actions">
          <div class="sk-line shimmer sk-w-55"></div>
        </div>
      </div>
      <ng-container *ngFor="let _ of skeletonRows">
        <div class="sk-row sk-data-row">
          <div class="sk-cell sk-file sk-column">
            <div class="sk-line shimmer sk-w-75"></div>
            <div class="sk-line shimmer sk-w-45"></div>
          </div>
          <div class="sk-cell sk-medium">
            <div class="sk-line shimmer sk-w-70"></div>
          </div>
          <div class="sk-cell sk-medium">
            <div class="sk-line shimmer sk-pill"></div>
          </div>
          <div class="sk-cell sk-center">
            <div class="sk-circle shimmer"></div>
          </div>
          <div class="sk-cell sk-date sk-column">
            <div class="sk-line shimmer sk-w-75"></div>
            <div class="sk-line shimmer sk-w-50"></div>
          </div>
          <div class="sk-cell sk-review">
            <div class="sk-circle shimmer"></div>
          </div>
          <div class="sk-cell sk-actions">
            <div class="sk-circle shimmer"></div>
          </div>
        </div>
      </ng-container>
    </div>

    <div class="table-wrapper" *ngIf="!isLoadingData || isFiltering">
      <table
        mat-table
        [dataSource]="tableDataSource"
        matSort
        class="picnic-table"
      >
        <!-- 1. F. Operación Column (Fixed Sticky) -->
        <ng-container matColumnDef="fechaOperacion">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="sticky-col col-fecha"
          >
            F. Operación
          </th>
          <td
            mat-cell
            *matCellDef="let elementRow"
            class="sticky-col col-fecha"
          >
            <div class="date-cell">
              <span class="primary-date">{{
                formatLocalDateToDisplay(elementRow.fechaOperacion)
              }}</span>
            </div>
          </td>
        </ng-container>

        <!-- 2. File Column (Fixed Sticky: nombreItinerario + fileNumber) -->
        <ng-container matColumnDef="fileNumber">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="sticky-col col-file"
          >
            File
          </th>
          <td mat-cell *matCellDef="let elementRow" class="sticky-col col-file">
            <div
              class="file-cell"
              [matTooltip]="
                (elementRow.nombreItinerario || '') +
                ' - ' +
                elementRow.fileNumber +
                (elementRow.isSSFFPadre ? ' (Salida Fija / File Padre)' : '')
              "
            >
              <span class="file-itinerary-name">{{
                elementRow.nombreItinerario || "-"
              }}</span>
              <div class="file-code-row">
                <span class="file-code-pill">
                  <i-tabler name="file-text"></i-tabler>
                  <span>{{ elementRow.fileNumber }}</span>
                </span>
                <span class="file-padre-badge" *ngIf="elementRow.isSSFFPadre">
                  <i-tabler name="layers-intersect"></i-tabler>
                  <span>SSFF</span>
                </span>
              </div>
            </div>
          </td>
        </ng-container>

        <!-- 3. Client Name Column (Fixed Sticky) -->
        <ng-container matColumnDef="nameClient">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="sticky-col col-client"
          >
            Cliente
          </th>
          <td
            mat-cell
            *matCellDef="let elementRow"
            class="sticky-col col-client"
          >
            <span class="client-title" [matTooltip]="elementRow.nameClient">{{
              elementRow.nameClient
            }}</span>
          </td>
        </ng-container>

        <!-- 4. Nombre Itinerario Column (Fixed Sticky) -->
        <ng-container matColumnDef="nombreItinerario">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="sticky-col col-itinerary"
          >
            Itinerario
          </th>
          <td
            mat-cell
            *matCellDef="let elementRow"
            class="sticky-col col-itinerary"
          >
            <span
              class="itinerary-text"
              [matTooltip]="elementRow.nombreItinerario"
              >{{ elementRow.nombreItinerario }}</span
            >
          </td>
        </ng-container>

        <!-- 4. Ejecutivo(a) de Reservas Column (reservationExecutive) -->
        <ng-container matColumnDef="reservationExecutive">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="col-executive-header"
          >
            Ejecutivo(a)
          </th>
          <td mat-cell *matCellDef="let elementRow" class="col-executive-cell">
            <div
              class="executive-list-container"
              *ngIf="
                elementRow.reservationExecutives &&
                  elementRow.reservationExecutives.length > 0;
                else noExecutive
              "
              [matTooltip]="
                'Ejecutivo(a) de Reservas: ' +
                elementRow.reservationExecutives.join(', ')
              "
            >
              <span
                class="executive-email-tag"
                *ngFor="let executiveEmail of elementRow.reservationExecutives"
              >
                <i-tabler name="mail" class="executive-mail-icon"></i-tabler>
                <span class="executive-email-text">{{ executiveEmail }}</span>
              </span>
            </div>
            <ng-template #noExecutive>
              <span class="no-executive-pill">-</span>
            </ng-template>
          </td>
        </ng-container>

        <!-- 6. Guía Principal Column -->
        <ng-container matColumnDef="guiaPrincipal">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="text-center"
          >
            Guía Principal
          </th>
          <td mat-cell *matCellDef="let elementRow" class="text-center">
            <ng-container *ngIf="elementRow.guiaPrincipal; else noGuide">
              <button
                mat-icon-button
                class="table-icon-button"
                matTooltip="GUÍA: {{ elementRow.guiaPrincipal }}"
                matTooltipPosition="above"
              >
                <span class="table-icon-shell tone-guide-assigned">
                  <i-tabler name="user" class="icon-tabler-user"></i-tabler>
                </span>
              </button>
            </ng-container>
            <ng-template #noGuide>
              <button
                mat-icon-button
                class="table-icon-button"
                matTooltip="Sin guía principal asignado"
                matTooltipPosition="above"
              >
                <span class="table-icon-shell tone-guide-empty">
                  <i-tabler name="user" class="icon-tabler-user"></i-tabler>
                </span>
              </button>
            </ng-template>
          </td>
        </ng-container>

        <!-- 7. TIPO Column (Fixed Sticky Column 4) -->
        <ng-container matColumnDef="tipoAlimento">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="sticky-col col-tipo-alimento text-center"
          >
            Alimento
          </th>
          <td
            mat-cell
            *matCellDef="let elementRow"
            class="sticky-col col-tipo-alimento text-center"
          >
            <span
              class="type-pill"
              [class.pill-snack]="
                (elementRow.foodType || '').toUpperCase().includes('SNACK')
              "
              [class.pill-picnic]="
                (elementRow.foodType || '').toUpperCase().includes('PICNIC')
              "
              [class.pill-boxlunch]="
                (elementRow.foodType || '').toUpperCase().includes('BOX LUNCH')
              "
              [class.pill-trek]="
                (elementRow.foodType || '').toUpperCase().includes('ALIM TREK')
              "
              [class.pill-donativo]="
                (elementRow.foodType || '').toUpperCase().includes('DONATIVO')
              "
            >
              {{ elementRow.foodType || "-" }}
            </span>
          </td>
        </ng-container>

        <!-- 8. Actividad Column -->
        <ng-container matColumnDef="activityName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Actividad</th>
          <td mat-cell *matCellDef="let elementRow">
            <span
              class="activity-name-text service-name-text"
              [matTooltip]="elementRow.activityName"
              >{{ elementRow.activityName }}</span
            >
          </td>
        </ng-container>

        <!-- 9. Pax Column (tone-success -> Verde) -->
        <ng-container matColumnDef="pax">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="col-headcount text-center"
          >
            Pax
          </th>
          <td
            mat-cell
            *matCellDef="let elementRow"
            class="col-headcount text-center"
          >
            <button
              mat-icon-button
              class="table-icon-button"
              [matTooltip]="
                'Pasajeros (Pax): ' +
                elementRow.picnicGroupDetails.activePaxCount
              "
              matTooltipPosition="above"
            >
              <span
                class="table-icon-shell"
                [ngClass]="
                  elementRow.picnicGroupDetails.activePaxCount > 0
                    ? 'tone-success'
                    : 'tone-empty'
                "
                [matBadge]="elementRow.picnicGroupDetails.activePaxCount"
                [matBadgeHidden]="
                  !elementRow.picnicGroupDetails.activePaxCount ||
                  elementRow.picnicGroupDetails.activePaxCount === 0
                "
              >
                <i-tabler name="users" class="icon-tabler-users"></i-tabler>
              </span>
            </button>
          </td>
        </ng-container>

        <!-- 10. Tc Column (tone-success -> Verde) -->
        <ng-container matColumnDef="tc">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="col-headcount text-center"
          >
            TC
          </th>
          <td
            mat-cell
            *matCellDef="let elementRow"
            class="col-headcount text-center"
          >
            <button
              mat-icon-button
              class="table-icon-button"
              [matTooltip]="
                'Tour Conductor (TC): ' +
                elementRow.picnicGroupDetails.activeTcCount
              "
              matTooltipPosition="above"
            >
              <span
                class="table-icon-shell"
                [ngClass]="
                  elementRow.picnicGroupDetails.activeTcCount > 0
                    ? 'tone-success'
                    : 'tone-empty'
                "
                [matBadge]="elementRow.picnicGroupDetails.activeTcCount"
                [matBadgeHidden]="
                  !elementRow.picnicGroupDetails.activeTcCount ||
                  elementRow.picnicGroupDetails.activeTcCount === 0
                "
              >
                <i-tabler name="user-star" class="icon-tabler-users"></i-tabler>
              </span>
            </button>
          </td>
        </ng-container>

        <!-- 11. Driver Column (tone-info -> Azul) -->
        <ng-container matColumnDef="driver">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="col-headcount text-center"
          >
            Chofer
          </th>
          <td
            mat-cell
            *matCellDef="let elementRow"
            class="col-headcount text-center"
          >
            <button
              mat-icon-button
              class="table-icon-button"
              [matTooltip]="
                'Chofer: ' + (elementRow.picnicGroupDetails.driverCount || 0)
              "
              matTooltipPosition="above"
            >
              <span
                class="table-icon-shell"
                [ngClass]="
                  elementRow.picnicGroupDetails.driverCount > 0
                    ? 'tone-info'
                    : 'tone-empty'
                "
                [matBadge]="elementRow.picnicGroupDetails.driverCount"
                [matBadgeHidden]="
                  !elementRow.picnicGroupDetails.driverCount ||
                  elementRow.picnicGroupDetails.driverCount === 0
                "
              >
                <i-tabler
                  name="steering-wheel"
                  class="icon-tabler-users"
                ></i-tabler>
              </span>
            </button>
          </td>
        </ng-container>

        <!-- 12. Guía Column (Personal en Ruta -> tone-success) -->
        <ng-container matColumnDef="guia">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="col-headcount text-center"
          >
            Guía
          </th>
          <td
            mat-cell
            *matCellDef="let elementRow"
            class="col-headcount text-center"
          >
            <button
              mat-icon-button
              class="table-icon-button"
              [matTooltip]="
                'Guía: ' + (elementRow.picnicGroupDetails.guiaCount || 0)
              "
              matTooltipPosition="above"
            >
              <span
                class="table-icon-shell"
                [ngClass]="
                  elementRow.picnicGroupDetails.guiaCount > 0
                    ? 'tone-success'
                    : 'tone-empty'
                "
                [matBadge]="elementRow.picnicGroupDetails.guiaCount"
                [matBadgeHidden]="
                  !elementRow.picnicGroupDetails.guiaCount ||
                  elementRow.picnicGroupDetails.guiaCount === 0
                "
              >
                <i-tabler name="trekking" class="icon-tabler-users"></i-tabler>
              </span>
            </button>
          </td>
        </ng-container>

        <!-- 13. Asist_guia Column (tone-info -> Azul) -->
        <ng-container matColumnDef="asistGuia">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="col-headcount text-center"
          >
            Asist. Guía
          </th>
          <td
            mat-cell
            *matCellDef="let elementRow"
            class="col-headcount text-center"
          >
            <button
              mat-icon-button
              class="table-icon-button"
              [matTooltip]="
                'Asist. Guía: ' +
                (elementRow.picnicGroupDetails.asistGuiaCount || 0)
              "
              matTooltipPosition="above"
            >
              <span
                class="table-icon-shell"
                [ngClass]="
                  elementRow.picnicGroupDetails.asistGuiaCount > 0
                    ? 'tone-info'
                    : 'tone-empty'
                "
                [matBadge]="elementRow.picnicGroupDetails.asistGuiaCount"
                [matBadgeHidden]="
                  !elementRow.picnicGroupDetails.asistGuiaCount ||
                  elementRow.picnicGroupDetails.asistGuiaCount === 0
                "
              >
                <i-tabler name="user-plus" class="icon-tabler-users"></i-tabler>
              </span>
            </button>
          </td>
        </ng-container>

        <!-- 14. Per. Campo Column (Cocina y Operaciones -> tone-campo) -->
        <ng-container matColumnDef="fieldStaff">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="col-headcount text-center"
          >
            Per. Campo
          </th>
          <td
            mat-cell
            *matCellDef="let elementRow"
            class="col-headcount text-center"
          >
            <button
              mat-icon-button
              class="table-icon-button"
              [matTooltip]="
                'Personal de Campo: ' +
                (elementRow.picnicGroupDetails.fieldStaffCount || 0)
              "
              matTooltipPosition="above"
            >
              <span
                class="table-icon-shell"
                [ngClass]="
                  elementRow.picnicGroupDetails.fieldStaffCount > 0
                    ? 'tone-campo'
                    : 'tone-empty'
                "
                [matBadge]="elementRow.picnicGroupDetails.fieldStaffCount"
                [matBadgeHidden]="
                  !elementRow.picnicGroupDetails.fieldStaffCount ||
                  elementRow.picnicGroupDetails.fieldStaffCount === 0
                "
              >
                <i-tabler
                  name="user-hexagon"
                  class="icon-tabler-users"
                ></i-tabler>
              </span>
            </button>
          </td>
        </ng-container>

        <!-- 15. Staff Column (Cocina y Operaciones -> tone-campo) -->
        <ng-container matColumnDef="staff">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="col-headcount text-center"
          >
            Staff
          </th>
          <td
            mat-cell
            *matCellDef="let elementRow"
            class="col-headcount text-center"
          >
            <button
              mat-icon-button
              class="table-icon-button"
              [matTooltip]="
                'Staff: ' + (elementRow.picnicGroupDetails.staffCount || 0)
              "
              matTooltipPosition="above"
            >
              <span
                class="table-icon-shell"
                [ngClass]="
                  elementRow.picnicGroupDetails.staffCount > 0
                    ? 'tone-campo'
                    : 'tone-empty'
                "
                [matBadge]="elementRow.picnicGroupDetails.staffCount"
                [matBadgeHidden]="
                  !elementRow.picnicGroupDetails.staffCount ||
                  elementRow.picnicGroupDetails.staffCount === 0
                "
              >
                <i-tabler name="user-star" class="icon-tabler-users"></i-tabler>
              </span>
            </button>
          </td>
        </ng-container>

        <!-- 16. Total Column -->
        <ng-container matColumnDef="total">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="col-headcount text-center col-total-header"
          >
            Total
          </th>
          <td
            mat-cell
            *matCellDef="let elementRow"
            class="col-headcount text-center col-total-cell"
          >
            <button
              type="button"
              class="total-action-pill"
              *ngIf="
                elementRow.picnicGroupDetails?.totalMesaCount > 0;
                else emptyTotal
              "
              (click)="openPicnicDetailsModal(elementRow)"
              [matTooltip]="
                'Total: ' +
                elementRow.picnicGroupDetails.totalMesaCount +
                ' comensales · Clic para ver desglose completo'
              "
              matTooltipPosition="above"
            >
              <div class="pill-icon-shell">
                <i-tabler name="users-group" class="pill-icon"></i-tabler>
              </div>
              <span class="pill-count">{{
                elementRow.picnicGroupDetails.totalMesaCount
              }}</span>
              <i-tabler name="chevron-right" class="pill-arrow"></i-tabler>
            </button>
            <ng-template #emptyTotal>
              <span class="empty-cell-dash">-</span>
            </ng-template>
          </td>
        </ng-container>

        <!-- 17. Infante <03 Años Column -->
        <ng-container matColumnDef="infante">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="col-headcount text-center"
          >
            Infante 0-2
          </th>
          <td
            mat-cell
            *matCellDef="let elementRow"
            class="col-headcount text-center"
          >
            <button
              mat-icon-button
              class="table-icon-button"
              [matTooltip]="
                'Infantes (< 3 años): ' +
                (elementRow.picnicGroupDetails.infantCount || 0)
              "
              matTooltipPosition="above"
            >
              <span
                class="table-icon-shell"
                [ngClass]="
                  elementRow.picnicGroupDetails.infantCount > 0
                    ? 'tone-infant'
                    : 'tone-empty'
                "
                [matBadge]="elementRow.picnicGroupDetails.infantCount"
                [matBadgeHidden]="
                  !elementRow.picnicGroupDetails.infantCount ||
                  elementRow.picnicGroupDetails.infantCount === 0
                "
              >
                <i-tabler
                  name="baby-bottle"
                  class="icon-tabler-users"
                ></i-tabler>
              </span>
            </button>
          </td>
        </ng-container>

        <!-- 18. Niño 03-12 Años Column -->
        <ng-container matColumnDef="nino">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="col-headcount text-center"
          >
            Niño 3-12
          </th>
          <td
            mat-cell
            *matCellDef="let elementRow"
            class="col-headcount text-center"
          >
            <button
              mat-icon-button
              class="table-icon-button"
              [matTooltip]="
                'Niños (3-12 años): ' +
                (elementRow.picnicGroupDetails.childCount || 0)
              "
              matTooltipPosition="above"
            >
              <span
                class="table-icon-shell"
                [ngClass]="
                  elementRow.picnicGroupDetails.childCount > 0
                    ? 'tone-child'
                    : 'tone-empty'
                "
                [matBadge]="elementRow.picnicGroupDetails.childCount"
                [matBadgeHidden]="
                  !elementRow.picnicGroupDetails.childCount ||
                  elementRow.picnicGroupDetails.childCount === 0
                "
              >
                <i-tabler name="mood-kid" class="icon-tabler-users"></i-tabler>
              </span>
            </button>
          </td>
        </ng-container>

        <!-- 19. Restricciones Alimentarias Column -->
        <ng-container matColumnDef="restriccionesAlimentarias">
          <th mat-header-cell *matHeaderCellDef class="col-restrictions-header">
            Restricciones
          </th>
          <td
            mat-cell
            *matCellDef="let elementRow"
            class="col-restrictions-cell"
          >
            <div
              class="restrictions-ui-box"
              *ngIf="
                hasValidDietaryRestrictions(
                  elementRow.picnicGroupDetails?.dietaryRestrictionsList
                );
                else noRestrictions
              "
            >
              <div
                class="restriction-passenger-list-wrapper"
                [class.is-expanded]="isRestrictionsExpanded(elementRow.id)"
              >
                <!-- Passenger restriction entries: "Nombre de pasajero: Restricciones" -->
                <div
                  class="passenger-restriction-entry"
                  [class.has-critical-alert]="isCriticalRestriction(paxItem)"
                  *ngFor="
                    let paxItem of isRestrictionsExpanded(elementRow.id)
                      ? getValidDietaryRestrictions(
                          elementRow.picnicGroupDetails?.dietaryRestrictionsList
                        )
                      : getValidDietaryRestrictions(
                          elementRow.picnicGroupDetails?.dietaryRestrictionsList
                        ).slice(0, 1)
                  "
                >
                  <span class="pax-name-prefix"
                    >{{ getPassengerNamePrefix(paxItem) }}:</span
                  >
                  <span class="pax-restrictions-body">{{
                    getPassengerRestrictionsBody(paxItem)
                  }}</span>
                </div>

                <!-- Counter badge "+X más" when multiple passengers have restrictions and collapsed -->
                <button
                  type="button"
                  class="btn-more-restrictions"
                  *ngIf="
                    !isRestrictionsExpanded(elementRow.id) &&
                    getValidDietaryRestrictions(
                      elementRow.picnicGroupDetails?.dietaryRestrictionsList
                    ).length > 1
                  "
                  (click)="toggleRestrictionsExpanded(elementRow.id, $event)"
                >
                  <span
                    >+{{
                      getValidDietaryRestrictions(
                        elementRow.picnicGroupDetails?.dietaryRestrictionsList
                      ).length - 1
                    }}
                    más</span
                  >
                </button>

                <!-- Collapse button when expanded -->
                <button
                  type="button"
                  class="btn-collapse-restrictions"
                  *ngIf="
                    isRestrictionsExpanded(elementRow.id) &&
                    getValidDietaryRestrictions(
                      elementRow.picnicGroupDetails?.dietaryRestrictionsList
                    ).length > 1
                  "
                  (click)="toggleRestrictionsExpanded(elementRow.id, $event)"
                >
                  <i-tabler name="chevron-up"></i-tabler>
                  <span>Menos</span>
                </button>
              </div>
            </div>

            <ng-template #noRestrictions>
              <span class="no-restrictions-pill">
                <i-tabler name="circle-check" class="check-icon"></i-tabler>
                <span>Sin restricciones</span>
              </span>
            </ng-template>
          </td>
        </ng-container>

        <!-- 20. Empresa de Transporte Column -->
        <ng-container [matColumnDef]="OperationalServiceCategory.TRANSPORT">
          <th mat-header-cell *matHeaderCellDef class="text-center">
            Emp. Transporte
          </th>
          <td mat-cell *matCellDef="let elementRow" class="text-center">
            <button
              type="button"
              class="service-count-pill"
              [ngClass]="
                resolveServicePillStatusClass(elementRow.empresaTransporte)
              "
              *ngIf="
                elementRow.empresaTransporte?.totalCount > 0;
                else emptyTransport
              "
              (click)="
                openOperationalServicesModal(
                  elementRow,
                  OperationalServiceCategory.TRANSPORT
                )
              "
              [matTooltip]="
                resolveServicePillTooltip(
                  'Empresa de Transporte',
                  elementRow.empresaTransporte
                )
              "
            >
              <i-tabler name="truck" class="pill-icon"></i-tabler>

              <span
                class="pill-status-text complete"
                *ngIf="isPillFullyConfirmed(elementRow.empresaTransporte)"
              >
                <i-tabler name="check" class="pill-check-icon"></i-tabler>
                <span>{{ elementRow.empresaTransporte.totalCount }} OS</span>
              </span>

              <span
                class="pill-status-text preliminary"
                *ngIf="
                  hasPillPreliminary(elementRow.empresaTransporte) &&
                  elementRow.empresaTransporte.generatedOrdersCount ===
                    elementRow.empresaTransporte.totalCount
                "
              >
                <span
                  >{{ elementRow.empresaTransporte.preliminaryOrdersCount }}/{{
                    elementRow.empresaTransporte.totalCount
                  }}
                  P</span
                >
              </span>

              <span
                class="pill-status-text partial"
                *ngIf="
                  elementRow.empresaTransporte.generatedOrdersCount > 0 &&
                  elementRow.empresaTransporte.generatedOrdersCount <
                    elementRow.empresaTransporte.totalCount
                "
              >
                <span
                  >{{ elementRow.empresaTransporte.generatedOrdersCount }}/{{
                    elementRow.empresaTransporte.totalCount
                  }}
                  OS</span
                >
              </span>

              <span
                class="pill-status-text pending"
                *ngIf="elementRow.empresaTransporte.generatedOrdersCount === 0"
              >
                <span>0/{{ elementRow.empresaTransporte.totalCount }} OS</span>
              </span>

              <i-tabler name="chevron-right" class="pill-arrow"></i-tabler>
            </button>
            <ng-template #emptyTransport>
              <span class="empty-cell-dash">-</span>
            </ng-template>
          </td>
        </ng-container>

        <!-- 21. Asistentes Picnic Column -->
        <ng-container [matColumnDef]="OperationalServiceCategory.ASSISTANT">
          <th mat-header-cell *matHeaderCellDef class="text-center">
            Asist. Picnic
          </th>
          <td mat-cell *matCellDef="let elementRow" class="text-center">
            <button
              type="button"
              class="service-count-pill"
              [ngClass]="
                resolveServicePillStatusClass(
                  elementRow.asistentePicnicServices
                )
              "
              *ngIf="
                elementRow.asistentePicnicServices?.totalCount > 0;
                else emptyAsist
              "
              (click)="
                openOperationalServicesModal(
                  elementRow,
                  OperationalServiceCategory.ASSISTANT
                )
              "
              [matTooltip]="
                resolveServicePillTooltip(
                  'Asistentes de Picnic',
                  elementRow.asistentePicnicServices
                )
              "
            >
              <i-tabler name="users" class="pill-icon"></i-tabler>

              <span
                class="pill-status-text complete"
                *ngIf="isPillFullyConfirmed(elementRow.asistentePicnicServices)"
              >
                <i-tabler name="check" class="pill-check-icon"></i-tabler>
                <span
                  >{{ elementRow.asistentePicnicServices.totalCount }} OS</span
                >
              </span>

              <span
                class="pill-status-text preliminary"
                *ngIf="
                  hasPillPreliminary(elementRow.asistentePicnicServices) &&
                  elementRow.asistentePicnicServices.generatedOrdersCount ===
                    elementRow.asistentePicnicServices.totalCount
                "
              >
                <span
                  >{{
                    elementRow.asistentePicnicServices.preliminaryOrdersCount
                  }}/{{ elementRow.asistentePicnicServices.totalCount }} P</span
                >
              </span>

              <span
                class="pill-status-text partial"
                *ngIf="
                  elementRow.asistentePicnicServices.generatedOrdersCount > 0 &&
                  elementRow.asistentePicnicServices.generatedOrdersCount <
                    elementRow.asistentePicnicServices.totalCount
                "
              >
                <span
                  >{{
                    elementRow.asistentePicnicServices.generatedOrdersCount
                  }}/{{
                    elementRow.asistentePicnicServices.totalCount
                  }}
                  OS</span
                >
              </span>

              <span
                class="pill-status-text pending"
                *ngIf="
                  elementRow.asistentePicnicServices.generatedOrdersCount === 0
                "
              >
                <span
                  >0/{{
                    elementRow.asistentePicnicServices.totalCount
                  }}
                  OS</span
                >
              </span>

              <i-tabler name="chevron-right" class="pill-arrow"></i-tabler>
            </button>
            <ng-template #emptyAsist>
              <span class="empty-cell-dash">-</span>
            </ng-template>
          </td>
        </ng-container>

        <!-- 22. Bañero Column -->
        <ng-container
          [matColumnDef]="OperationalServiceCategory.BATHROOM_ATTENDANT"
        >
          <th mat-header-cell *matHeaderCellDef class="text-center">Bañero</th>
          <td mat-cell *matCellDef="let elementRow" class="text-center">
            <button
              type="button"
              class="service-count-pill"
              [ngClass]="
                resolveServicePillStatusClass(elementRow.baneroService)
              "
              *ngIf="elementRow.baneroService?.totalCount > 0; else emptyBanero"
              (click)="
                openOperationalServicesModal(
                  elementRow,
                  OperationalServiceCategory.BATHROOM_ATTENDANT
                )
              "
              [matTooltip]="
                resolveServicePillTooltip(
                  'Servicio de Bañero',
                  elementRow.baneroService
                )
              "
            >
              <i-tabler name="pool" class="pill-icon"></i-tabler>

              <span
                class="pill-status-text complete"
                *ngIf="isPillFullyConfirmed(elementRow.baneroService)"
              >
                <i-tabler name="check" class="pill-check-icon"></i-tabler>
                <span>{{ elementRow.baneroService.totalCount }} OS</span>
              </span>

              <span
                class="pill-status-text preliminary"
                *ngIf="
                  hasPillPreliminary(elementRow.baneroService) &&
                  elementRow.baneroService.generatedOrdersCount ===
                    elementRow.baneroService.totalCount
                "
              >
                <span
                  >{{ elementRow.baneroService.preliminaryOrdersCount }}/{{
                    elementRow.baneroService.totalCount
                  }}
                  P</span
                >
              </span>

              <span
                class="pill-status-text partial"
                *ngIf="
                  elementRow.baneroService.generatedOrdersCount > 0 &&
                  elementRow.baneroService.generatedOrdersCount <
                    elementRow.baneroService.totalCount
                "
              >
                <span
                  >{{ elementRow.baneroService.generatedOrdersCount }}/{{
                    elementRow.baneroService.totalCount
                  }}
                  OS</span
                >
              </span>

              <span
                class="pill-status-text pending"
                *ngIf="elementRow.baneroService.generatedOrdersCount === 0"
              >
                <span>0/{{ elementRow.baneroService.totalCount }} OS</span>
              </span>

              <i-tabler name="chevron-right" class="pill-arrow"></i-tabler>
            </button>
            <ng-template #emptyBanero>
              <span class="empty-cell-dash">-</span>
            </ng-template>
          </td>
        </ng-container>

        <!-- 22. Operador de Picnic Column -->
        <ng-container [matColumnDef]="OperationalServiceCategory.OPERATOR">
          <th mat-header-cell *matHeaderCellDef class="text-center">
            Espacio Picnic
          </th>
          <td mat-cell *matCellDef="let elementRow" class="text-center">
            <button
              type="button"
              class="service-count-pill"
              [ngClass]="
                resolveServicePillStatusClass(elementRow.operadorPicnicService)
              "
              *ngIf="
                elementRow.operadorPicnicService?.totalCount > 0;
                else emptyOperador
              "
              (click)="
                openOperationalServicesModal(
                  elementRow,
                  OperationalServiceCategory.OPERATOR
                )
              "
              [matTooltip]="
                resolveServicePillTooltip(
                  'Operador de Picnic',
                  elementRow.operadorPicnicService
                )
              "
            >
              <i-tabler name="briefcase" class="pill-icon"></i-tabler>

              <span
                class="pill-status-text complete"
                *ngIf="isPillFullyConfirmed(elementRow.operadorPicnicService)"
              >
                <i-tabler name="check" class="pill-check-icon"></i-tabler>
                <span
                  >{{ elementRow.operadorPicnicService.totalCount }} OS</span
                >
              </span>

              <span
                class="pill-status-text preliminary"
                *ngIf="
                  hasPillPreliminary(elementRow.operadorPicnicService) &&
                  elementRow.operadorPicnicService.generatedOrdersCount ===
                    elementRow.operadorPicnicService.totalCount
                "
              >
                <span
                  >{{
                    elementRow.operadorPicnicService.preliminaryOrdersCount
                  }}/{{ elementRow.operadorPicnicService.totalCount }} P</span
                >
              </span>

              <span
                class="pill-status-text partial"
                *ngIf="
                  elementRow.operadorPicnicService.generatedOrdersCount > 0 &&
                  elementRow.operadorPicnicService.generatedOrdersCount <
                    elementRow.operadorPicnicService.totalCount
                "
              >
                <span
                  >{{
                    elementRow.operadorPicnicService.generatedOrdersCount
                  }}/{{ elementRow.operadorPicnicService.totalCount }} OS</span
                >
              </span>

              <span
                class="pill-status-text pending"
                *ngIf="
                  elementRow.operadorPicnicService.generatedOrdersCount === 0
                "
              >
                <span
                  >0/{{ elementRow.operadorPicnicService.totalCount }} OS</span
                >
              </span>

              <i-tabler name="chevron-right" class="pill-arrow"></i-tabler>
            </button>
            <ng-template #emptyOperador>
              <span class="empty-cell-dash">-</span>
            </ng-template>
          </td>
        </ng-container>

        <!-- 23. Revisado Pedido Column -->
        <ng-container matColumnDef="isPicnicOrderReviewed">
          <th mat-header-cell *matHeaderCellDef class="text-center">
            Rev. Pedido
          </th>
          <td mat-cell *matCellDef="let activityFood" class="text-center">
            <div class="revised-order-cell-container">
              <!-- Loading spinner while updating this specific row in background -->
              <div
                *ngIf="
                  isOrderReviewRowUpdating(activityFood.id);
                  else reviewCheckboxTemplate
                "
                class="revised-order-loader"
                matTooltip="Actualizando revisión del pedido..."
              >
                <span class="spinner-ring"></span>
              </div>

              <!-- Interactive checkbox with confirmation prompt on click -->
              <ng-template #reviewCheckboxTemplate>
                <mat-checkbox
                  [checked]="activityFood.isPicnicOrderReviewed"
                  [disabled]="isAnyOrderReviewRowUpdating"
                  (click)="
                    $event.preventDefault();
                    handleTogglePicnicOrderReview(
                      activityFood,
                      !activityFood.isPicnicOrderReviewed
                    )
                  "
                  color="primary"
                  class="prog-checkbox"
                  [matTooltip]="getOrderReviewTooltip(activityFood)"
                ></mat-checkbox>
              </ng-template>
            </div>
          </td>
        </ng-container>

        <!-- 24. Rev. Biblia Column -->
        <ng-container matColumnDef="pendingCsReviews">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="text-center"
          >
            Rev. Biblia
          </th>
          <td mat-cell *matCellDef="let elementRow" class="text-center">
            <span
              class="status-pill"
              [class.status-ok]="elementRow.revisadoBiblia === false"
              [class.status-pending]="elementRow.revisadoBiblia === true"
              [class.status-none]="
                elementRow.revisadoBiblia === null ||
                elementRow.revisadoBiblia === undefined
              "
              [matTooltip]="
                elementRow.revisadoBiblia === true
                  ? 'Revisión AC pendiente'
                  : elementRow.revisadoBiblia === false
                    ? 'Revisión AC resuelta'
                    : 'Sin revisión AC creada'
              "
            >
              {{
                elementRow.revisadoBiblia === true
                  ? "Pendiente"
                  : elementRow.revisadoBiblia === false
                    ? "OK"
                    : "Sin Revisión"
              }}
            </span>
          </td>
        </ng-container>

        <!-- 25. Observaciones Programadora Column (Read Only) -->
        <ng-container matColumnDef="observacionProgramadora">
          <th mat-header-cell *matHeaderCellDef class="col-obs-header">
            Observaciones
          </th>
          <td mat-cell *matCellDef="let elementRow" class="col-obs-cell">
            <div
              class="observation-card-ui"
              *ngIf="
                elementRow.observacionProgramadora &&
                  elementRow.observacionProgramadora.trim() !== '-' &&
                  elementRow.observacionProgramadora.trim() !== '';
                else emptyObservationTemplate
              "
              [class.is-expanded]="isObservationExpanded(elementRow.id)"
              [matTooltip]="
                !isObservationExpanded(elementRow.id) &&
                isObservationLong(elementRow.observacionProgramadora)
                  ? elementRow.observacionProgramadora
                  : ''
              "
              matTooltipClass="custom-table-tooltip"
            >
              <div class="obs-card-layout">
                <div class="obs-icon-shell">
                  <i-tabler name="notes" class="obs-icon"></i-tabler>
                </div>
                <div class="obs-text-wrapper">
                  <p
                    class="obs-text"
                    [class.is-clamped]="!isObservationExpanded(elementRow.id)"
                  >
                    {{ elementRow.observacionProgramadora }}
                  </p>
                  <button
                    type="button"
                    class="btn-toggle-obs"
                    *ngIf="
                      isObservationLong(elementRow.observacionProgramadora)
                    "
                    (click)="toggleObservationExpanded(elementRow.id, $event)"
                  >
                    <i-tabler
                      [name]="
                        isObservationExpanded(elementRow.id)
                          ? 'chevron-up'
                          : 'chevron-down'
                      "
                      class="toggle-chevron"
                    ></i-tabler>
                    <span>{{
                      isObservationExpanded(elementRow.id)
                        ? "Ver menos"
                        : "Ver más"
                    }}</span>
                  </button>
                </div>
              </div>
            </div>

            <ng-template #emptyObservationTemplate>
              <span class="empty-obs-dash" matTooltip="Sin observaciones"
                >-</span
              >
            </ng-template>
          </td>
        </ng-container>

        <tr
          mat-header-row
          *matHeaderRowDef="displayedTableColumns; sticky: true"
        ></tr>
        <tr mat-row *matRowDef="let row; columns: displayedTableColumns"></tr>
      </table>

      <!-- Empty State Component -->
      <div
        class="table-empty-state"
        *ngIf="!isLoadingData && masterPicnicItems.length === 0"
      >
        <i-tabler name="search-off" class="empty-icon"></i-tabler>
        <h3 class="empty-title">No se encontraron servicios de picnic</h3>
        <p class="empty-subtitle">
          No hay registros que coincidan con los filtros aplicados. Intenta
          ajustar el rango de fechas o restablecer los filtros.
        </p>
        <button
          mat-stroked-button
          class="btn-reset-empty"
          (click)="resetTableFilters()"
        >
          <i-tabler name="refresh"></i-tabler>
          <span>Restablecer filtros</span>
        </button>
      </div>
    </div>

    <!-- Paginator Component -->
    <div class="paginator-container" *ngIf="!isLoadingData || isFiltering">
      <mat-paginator
        [length]="paginatorLength"
        [pageSize]="pageSize"
        [pageIndex]="pageIndex"
        [pageSizeOptions]="pageSizeOptions"
        [disabled]="isLoadingData || isFiltering"
        (page)="onPaginatorChange($event)"
        class="custom-paginator-pill"
      ></mat-paginator>
    </div>
  </div>
</div>
